import { ApmBase } from '@elastic/apm-rum';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { ELASTIC_APM_SERVICENAME } from '../constants/app.constants';
import { ApmService } from '@elastic/apm-rum-angular';

@Injectable({
  providedIn: 'root',
})
export class CustomApmService {
  apmBase!: ApmBase;

  constructor(
    private readonly _apmService: ApmService,
    private readonly _msalService: MsalService,
  ) {}

  /**
   * Initializes the Elastic APM (Application Performance Monitoring) service for the application.
   *
   * This method sets up the APM base instance using the provided service name, server URL, and environment
   * variables. After initialization, it also sets the user context for APM tracking.
   *
   * @remarks
   * - Relies on environment variables for configuration.
   * - Should be called during application startup to enable performance monitoring.
   *
   * @see {@link https://www.elastic.co/docs/reference/apm/agents/rum-js/angular-integration APM RUM Agent Documentation}
   */
  initializeApm(): void {
    this.apmBase = this._apmService.init({
      serviceName: ELASTIC_APM_SERVICENAME,
      serverUrl: environment.ELASTIC_APM_SERVER_URL,
      environment: environment.ENV_NAME,
    });
    this.setUserContext();
  }

  /**
   * Initializes the APM service and sets the user context based on the active account.
   * This method is called in the constructor to ensure that the user context is set
   * as soon as the service is instantiated.
   */
  private async setUserContext(): Promise<void> {
    await this._msalService.instance.initialize?.();
    const account = this._msalService.instance?.getAllAccounts()[0];
    if (account) {
      this.apmBase.setUserContext({
        id: account.homeAccountId,
        username: account?.name,
        email: account?.localAccountId,
      });
    }
  }
}
